import React from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import { useRef } from 'react';
import { GET } from '../../services/api';
import { format, parseISO } from 'date-fns';
import { notify } from '../../components/Notification';
import { resolveFileSrc } from '../../helpers/fileSrcResolver';
import readXlsxFileBrowser from 'read-excel-file';
import * as Yup from 'yup';
import Button from '../../components/Button';
import Recdal from 'recdal';
import { DownloadPlaylistButton, ModalContent } from './styles';
import { Heading3 } from '../../components/Typography';
import { Form, Input } from '../../components/Form';
import { BsDownload } from 'react-icons/bs';
import PlaylistVisualization from '../../components/PlaylistVisualization';

export const ViewPlaylist = ({ contract }) => {
	const modalRef = useRef();
	const playlistFormRef = useRef();

	const [playlistLink, setPlaylistLink] = useState('');
	const [playlistRows, setPlaylistRows] = useState([]);
	const [fetchingPlaylist, setFetchingPlaylist] = useState(false);

	const handleFetchDayPlaylist = useCallback(
		async (formData) => {
			try {
				const validationSchema = Yup.object().shape({
					date: Yup.string().required('Informe o dia'),
				});

				await validationSchema.validate(formData);

				setPlaylistLink('');
				setPlaylistRows([]);
				setFetchingPlaylist(true);
				playlistFormRef.current.setFieldError('date', '');
				modalRef.current.lock();

				const date = format(parseISO(formData.date), 'dd/MM/yyyy');
				const url = `/api/v2/playlists?program=${contract?.value?.program?._id}&date=${date}`;
				const {
					data: { playlists },
				} = await GET(url);

				if (!playlists.length) {
					modalRef.current.unlock();
					setFetchingPlaylist(false);
					return notify(
						'warn',
						'Não há playlists cadastradas para o programa selecionado nesse dia'
					);
				}

				const playlist = playlists[0];
				const playlistLink = resolveFileSrc({
					fileName: playlist.filename,
					customS3Bucket: process.env.REACT_APP_PLAYLISTS_BUCKET,
				});

				let blob = await fetch(playlistLink);

				blob = await blob.blob();
				const rows = await readXlsxFileBrowser(blob);

				modalRef.current.unlock();
				setFetchingPlaylist(false);
				setPlaylistRows(rows);
				setPlaylistLink(playlistLink);
			} catch (error) {
				if (error instanceof Yup.ValidationError) {
					return playlistFormRef.current.setFieldError('date', error.message);
				}
			}
		},
		[contract]
	);

	const handleCloseModal = useCallback(() => {
		setPlaylistLink('');
		setPlaylistRows([]);
		modalRef.current.close();
	}, []);

	return (
		<>
			<Button onClick={() => modalRef.current.open()} disabled={!contract} variant='outlined'>
				Ver Playlist
			</Button>

			<Recdal
				ref={modalRef}
				awaitBeforeOpening={false}
				awaitBeforeClosing={false}
				overlay={{
					style: {
						background: 'rgba(0, 0, 0, .4)',
					},
				}}>
				<ModalContent>
					<header>
						<Heading3>Buscar playlist</Heading3>
					</header>
					<Form ref={playlistFormRef} onSubmit={handleFetchDayPlaylist}>
						<Input size={4} name='date' type='date' label='Selecione o dia' />

						{playlistLink && (
							<DownloadPlaylistButton href={playlistLink}>
								<BsDownload /> <span>Baixar Playlist</span>
							</DownloadPlaylistButton>
						)}
					</Form>

					{playlistRows.length !== 0 && <PlaylistVisualization rows={playlistRows} />}

					<div className='buttons'>
						<Button
							color='#5f5f5f'
							variant='outlined'
							onClick={handleCloseModal}
							disabled={fetchingPlaylist}>
							Cancelar
						</Button>
						<Button
							color='success'
							onClick={() => playlistFormRef.current.submitForm()}
							loading={fetchingPlaylist}>
							Buscar Playlist
						</Button>
					</div>
				</ModalContent>
			</Recdal>
		</>
	);
};
